import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";
import ErrorPage from "./ErrorPage";

export default function NewPanApplicationForm({ show, onClose, onSuccess }) {
  const { userid } = useSession();
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    const requiredFields = [
      "title",
      "firstName",
      "lastName",
      "mobile",
      "fatherFirstName",
      "fatherLastName",
      "dob",
      "gender",
      "place",
      "type",
    ];

    requiredFields.forEach((field) => {
      const value = document.querySelector(`[name="${field}"]`)?.value?.trim();
      if (!value) {
        newErrors[field] = `${field} is required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please fill all required fields", "danger");
      return;
    }

    const formData = new FormData(document.getElementById("new-pan-form"));
    formData.append("userid", userid);
    formData.append("action", "New Application");


    try {
      const response = await fetchWrapper("https://pro.mokshiq.in/nsdl_action", {
        method: "POST",
        body: formData,
      });

      //   if (!response.ok) {
      //     showMainToast("Something went wrong!", "danger");
      //     return;
      //   }

      //   const result = await response.json();
      if (response.status) {
        debugger;
        showMainToast(response.response || "PAN Application Submitted!", "success");
        const reqData = response.data; // your full 'req' value as JSON or string

        // Create a form element dynamically
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://assisted-service.egov.proteantech.in/SpringBootFormHandling/newPanReq";
        form.target = "_blank"; // open in new tab

        // Create hidden input for 'req'
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "req";
        input.value = reqData; // make sure it's a string
        form.appendChild(input);

        // Append the form to body and submit
        document.body.appendChild(form);
        form.submit();

        // Optional: remove the form after submission
        document.body.removeChild(form);
        if (onSuccess) onSuccess(response.data);
        onClose();
      } else {
        showMainToast(response.data || "Submission failed", "danger");
      }
    } catch (err) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="New PAN Application"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: "Submit", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="new-pan-form">
          {/* Title */}
          <div className="col-md-6">
            <label className="form-label">Title</label>
            <select
              name="title"
              className={`form-select ${errors.title ? "is-invalid" : ""}`}
            >
              <option value="">-- Select --</option>
              <option value="1">Mr.</option>
              <option value="2">Mrs.</option>
              <option value="3">Transgender</option>
            </select>
            {errors.title && <div className="text-danger mt-1">{errors.title}</div>}
          </div>

          {/* First Name */}
          <div className="col-md-6">
            <label className="form-label">First Name</label>
            <input
              className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
              name="firstName"
              type="text"
            />
            {errors.firstName && <div className="text-danger mt-1">{errors.firstName}</div>}
          </div>

          {/* Middle Name */}
          <div className="col-md-6">
            <label className="form-label">Middle Name</label>
            <input className="form-control" name="middleName" type="text" />
          </div>

          {/* Last Name */}
          <div className="col-md-6">
            <label className="form-label">Last Name</label>
            <input
              className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
              name="lastName"
              type="text"
            />
            {errors.lastName && <div className="text-danger mt-1">{errors.lastName}</div>}
          </div>

          {/* Mobile */}
          <div className="col-md-6">
            <label className="form-label">Mobile</label>
            <input
              className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
              name="mobile"
              type="tel"
              maxLength="10"
            />
            {errors.mobile && <div className="text-danger mt-1">{errors.mobile}</div>}
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input className="form-control" name="email" type="email" />
          </div>

          {/* Father First Name */}
          <div className="col-md-6">
            <label className="form-label">Father First Name</label>
            <input
              className={`form-control ${errors.fatherFirstName ? "is-invalid" : ""}`}
              name="fatherFirstName"
              type="text"
            />
            {errors.fatherFirstName && <div className="text-danger mt-1">{errors.fatherFirstName}</div>}
          </div>

          {/* Father Middle Name */}
          <div className="col-md-6">
            <label className="form-label">Father Middle Name</label>
            <input className="form-control" name="fatherMiddleName" type="text" />
          </div>

          {/* Father Last Name */}
          <div className="col-md-6">
            <label className="form-label">Father Last Name</label>
            <input
              className={`form-control ${errors.fatherLastName ? "is-invalid" : ""}`}
              name="fatherLastName"
              type="text"
            />
            {errors.fatherLastName && <div className="text-danger mt-1">{errors.fatherLastName}</div>}
          </div>

          {/* DOB */}
          <div className="col-md-6">
            <label className="form-label">Date of Birth (DD/MM/YYYY)</label>
            <input
              className={`form-control ${errors.dob ? "is-invalid" : ""}`}
              name="dob"
              type="text"
              placeholder="DD/MM/YYYY"
            />
            {errors.dob && <div className="text-danger mt-1">{errors.dob}</div>}
          </div>

          {/* Gender */}
          <div className="col-md-6">
            <label className="form-label">Gender</label>
            <select
              name="gender"
              className={`form-select ${errors.gender ? "is-invalid" : ""}`}
            >
              <option value="">-- Select --</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="T">Transgender</option>
            </select>
            {errors.gender && <div className="text-danger mt-1">{errors.gender}</div>}
          </div>

          {/* Parent Name Print */}
          <div className="col-md-6">
            <label className="form-label">Parent Name (as to be printed)</label>
            <input className="form-control" name="parentNamePrint" type="text" />
          </div>

          {/* Place */}
          <div className="col-md-6">
            <label className="form-label">Place</label>
            <input
              className={`form-control ${errors.place ? "is-invalid" : ""}`}
              name="place"
              type="text"
            />
            {errors.place && <div className="text-danger mt-1">{errors.place}</div>}
          </div>

          {/* Request ID */}
          {/* <div className="col-md-6">
            <label className="form-label">Request ID</label>
            <input
              className={`form-control ${errors.requestId ? "is-invalid" : ""}`}
              name="requestId"
              type="text"
            />
            {errors.requestId && <div className="text-danger mt-1">{errors.requestId}</div>}
          </div> */}

          {/* Agent ID */}
          {/* <div className="col-md-6">
            <label className="form-label">Agent ID</label>
            <input
              className={`form-control ${errors.agentId ? "is-invalid" : ""}`}
              name="agentId"
              type="text"
            />
            {errors.agentId && <div className="text-danger mt-1">{errors.agentId}</div>}
          </div> */}

          {/* Return URL */}
          {/* <div className="col-md-12">
            <label className="form-label">Return URL</label>
            <input
              className={`form-control ${errors.returnUrl ? "is-invalid" : ""}`}
              name="returnUrl"
              type="url"
            />
            {errors.returnUrl && <div className="text-danger mt-1">{errors.returnUrl}</div>}
          </div> */}

          {/* Type */}
          <div className="col-md-6">
            <label className="form-label">Application Type</label>
            <select
              name="type"
              className={`form-select ${errors.type ? "is-invalid" : ""}`}
            >
              <option value="">-- Select --</option>
              <option value="N">New Pan Apply</option>
              <option value="D">Doc Based Pan Apply</option>
              <option value="C">Correction Apply</option>
              <option value="E">Doc Based Correction Apply</option>
            </select>
            {errors.type && <div className="text-danger mt-1">{errors.type}</div>}
          </div>

          {/* PAN (only for C/E types) */}
          {/* <div className="col-md-6">
            <label className="form-label">PAN (For Correction)</label>
            <input className="form-control" name="pan" type="text" maxLength="10" />
          </div>
          <div className="col-md-6">
            <label className="form-label">PAN1</label>
            <input className="form-control" name="pan1" type="text" maxLength="10" />
          </div>
          <div className="col-md-6">
            <label className="form-label">PAN2</label>
            <input className="form-control" name="pan2" type="text" maxLength="10" />
          </div>
          <div className="col-md-6">
            <label className="form-label">PAN3</label>
            <input className="form-control" name="pan3" type="text" maxLength="10" />
          </div>
          <div className="col-md-6">
            <label className="form-label">PAN4</label>
            <input className="form-control" name="pan4" type="text" maxLength="10" />
          </div> */}
        </form>
      </div>
    </BaseModal>
  );
}
